import useUpdateEffect from '@restart/hooks/useUpdateEffect';
import classNames from 'classnames/bind';
import React, { useState } from 'react';
import { RiDvdLine } from 'react-icons/ri';
import { useDispatch } from 'react-redux';
import { v4 as uuidv4 } from 'uuid';

import styles from './common.module.scss';

import actions from '@/actions';
import ConfirmSlider from '@/components/ui/ConfirmSlider';
import { FieldNumber } from '@/components/ui/kit/Field';
import Select from '@/components/ui/kit/Select';
import LabelGroup from '@/components/ui/LabelGroup';
import useActionCommand from '@/hooks/command/mavlink/useActionCommand';
import { NotifierService as notifier } from '@/libs/Notifier';
import { executeMavLinkCommand } from '@/utils/CommandUtils';

const cx = classNames.bind(styles);

const Panel = ({ data: robots }) => {
  const dispatch = useDispatch();
  const [isProcessing, setProcessing] = useState(false);
  const [gripperId, setGripperId] = useState(1);
  const [action, setAction] = useState();
  const actionCommand = useActionCommand();

  const handleBlur = (e) => {
    setGripperId(Math.trunc(e.target.value));
  };

  const handleChange = (e) => {
    setAction(e.target.value);
  };

  //#region Process Functions
  const process = async (robot) => {
    try {
      await executeMavLinkCommand(robot, actionCommand.gripper(gripperId, action));

      onSuccess(robot);
    } catch (error) {
      onFailure(robot);
    }
  };
  //#endregion

  //#region Result Handlers
  const onSuccess = (robot) => {
    let actionText;
    switch (action) {
      case 0:
        actionText = 'opened';
        break;
      case 1:
        actionText = 'closed';
        break;
      case 2:
        actionText = 'stopped';
        break;
      default:
        break;
    }

    notifier.success(`Gripper ${actionText} successfully on ${robot.name}.`);
    setProcessing(false);
  };

  const onFailure = (robot) => {
    notifier.error(`Failed to control gripper on ${robot.name}.`);
    setProcessing(false);
  };
  //#endregion

  useUpdateEffect(() => {
    if (!isProcessing) {
      dispatch(actions.command.resetActivePanels());
      return;
    }

    robots.forEach((robot) => process(robot));
  }, [isProcessing]);

  const doCommand = () => {
    // 처리 중 상태로 변경
    setProcessing(true);
  };

  return (
    <div className={cx('container')}>
      <div className={cx('desc')}>Controls gripper to open, close, or stop</div>
      <div className={cx('form')}>
        <LabelGroup htmlFor="number" label="Instance Number">
          <div className={cx('fieldWrapper')}>
            <FieldNumber id="number" name="gripperId" defaultValue={gripperId} onBlur={handleBlur} />
          </div>
        </LabelGroup>
        <LabelGroup htmlFor="action" label="Action">
          <Select name="action" value={action} onChange={handleChange}>
            <option value={0}>Open</option>
            <option value={1}>Close</option>
            <option value={2}>Stop</option>
          </Select>
        </LabelGroup>
      </div>
      <ConfirmSlider
        width="100%"
        height={40}
        onConfirm={doCommand}
        isProcessing={isProcessing}
        labelStyle={{ fontSize: 12 }}
      />
    </div>
  );
};

const Command = {};
Command.id = uuidv4();
Command.name = 'Gripper';
Command.displayMode = 'sidebar';
Command.singleRobotOnly = false;
Command.commanderOnly = true;
Command.Icon = RiDvdLine;
Command.Panel = Panel;

export default Command;
